import { render } from "./AddSezionePage.vue?vue&type=template&id=79f9cb77"
import script from "./AddSezionePage.vue?vue&type=script&lang=js"
export * from "./AddSezionePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__